import { connectorIdsBySpace } from "../../shared/liveConnectorUsage";
import { queries } from "../../shared/queries";
import { usedConnectorsForSpace } from "../lib/usedSuppliersForSpace";
import { useQuery } from "@rocicorp/zero/react";

export function useSpaceUsedSuppliers<
  T extends { id: string; usages?: readonly { type: string; refId: string }[] },
>(connectors: readonly T[], spaceIds: readonly string[]) {
  const [spaces = [], spacesResult] = useQuery(
    spaceIds.length > 0
      ? queries.connectorUsagesBySpace({ spaceIds: [...spaceIds] })
      : undefined
  );
  const liveAppIdsBySpace = connectorIdsBySpace(spaces);
  return {
    usedConnectorsForSpace: (spaceId: string) =>
      usedConnectorsForSpace(spaceId, connectors, liveAppIdsBySpace),
    usedConnectorsLoaded: spacesResult.type !== "unknown",
  };
}
